/* ==================================================================
   CATÁLOGO — DATOS DE DEMOSTRACIÓN (FASE 1)
   ------------------------------------------------------------------
   ⚠️ Productos y precios FICTICIOS. Sin Shopify, sin pagos, sin BBDD.
   Forma de los datos pensada para imitar la Shopify Storefront API
   (handle, variants, options, images). En la fase 2 solo habrá que
   sustituir `src/services/catalog.js`.

   GALERÍAS: cada producto tiene `images` (array). Para reemplazar
   por las fotos reales de la marca, basta con sustituir las URLs.
================================================================== */

export const products = [
    {
        id: "fresh-roses",
        handle: "ramo-rosas-frescas",
        name: { es: "Ramo de Rosas Frescas", en: "Fresh Roses Bouquet" },
        desc: {
            es: "Rosas rojas frescas seleccionadas a mano, envueltas con cinta de satén bordeaux y tu mensaje en una tarjeta escrita a mano.",
            en: "Hand-selected fresh red roses wrapped with a bordeaux satin ribbon and your message on a handwritten card.",
        },
        images: [
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/80cc87ea508d55c8_78B8845F-261D-4C3B-B5BC-2839A8805B9F.png",
            "/images/ramo-50.jpg",
            "/images/ramo-75.jpg",
            "/images/ramo-100.jpg",
        ],
        options: {
            roseCounts: [
                { count: 25, price: 79 },
                { count: 50, price: 139 },
                { count: 75, price: 189 },
                { count: 100, price: 249 },
            ],
            shirt: false,
            message: true,
        },
        roseExtras: {
            cutoffHour: 18,
            redBalloon: { price: 10 },
            balloonText: { price: 10, maxLength: 40 },
            cardStyles: [
                { id: "blanca", label: { es: "Tarjeta en blanco", en: "Blank card" } },
                { id: "teamo", label: { es: "Tarjeta «Te amo»", en: "“I love you” card" } },
            ],
        },
    },
    {
        id: "custom-teddy",
        handle: "osito-personalizado",
        name: { es: "Osito Personalizado", en: "Personalized Teddy Bear" },
        desc: {
            es: "Osito de peluche gigante y suave, beige o marrón. Con o sin T-shirt personalizado: su nombre y tu mensaje estampados.",
            en: "Giant soft teddy bear, beige or brown. With or without a personalized t-shirt: their name and your message printed.",
        },
        images: [
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/98cd0bed01ffdc13_IMG_7251.webp",
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/e5489fc05a5da334_3F5B39C5-9BB9-4B97-A43D-FA66B3D34E09.png",
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/2aff0d86a38c0bc5_IMG_7252.webp",
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/01ed853c435cedfa_3F23AB23-2C96-4019-865B-8D71F8F205E0.png",
        ],
        options: {
            roseCounts: null,
            shirt: false,
            message: true,
        },
        teddyOptions: {
            colors: [
                { id: "beige", label: { es: "Beige", en: "Beige" }, dot: "#D8B58E", image: 0 },
                { id: "marron", label: { es: "Marrón", en: "Brown" }, dot: "#8B5E34", image: 2 },
            ],
            shirt: {
                price: 10,
                colors: [
                    { id: "negro", label: { es: "Negro", en: "Black" }, dot: "#181818" },
                ],
            },
            shirtText: { price: 10, maxLength: 15 },
        },
        basePrice: 65,
    },
    {
        id: "surprise-box-balloons",
        handle: "caja-sorpresa-globos",
        name: { es: "Caja Sorpresa con Globos", en: "Surprise Box with Balloons" },
        desc: {
            es: "Un gran cartón regalo con globos corazón inflados con helio: al abrirlo, salen flotando con tu mensaje.",
            en: "A large gift box with helium heart balloons: open it and they float out with your message.",
        },
        images: [
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/25b6ba365ed1b4ed_D64A02F8-C2F3-4391-B903-552D32750A81.png",
        ],
        options: {
            roseCounts: null,
            shirt: false,
            message: true,
        },
        basePrice: 55,
        extras: [
            {
                id: "bruma-vs",
                name: { es: "Bruma Victoria’s Secret", en: "Victoria’s Secret body mist" },
                desc: { es: "Un toque especial para ella.", en: "A special touch for her." },
                price: 25,
                image: "/extras/bruma.jpg",
            },
            {
                id: "ferrero",
                name: { es: "Bombones Ferrero Rocher", en: "Ferrero Rocher chocolates" },
                desc: { es: "Un dulce detalle para sorprender.", en: "A sweet detail to surprise." },
                price: 12,
                image: "/extras/ferrero.jpg",
            },
            {
                id: "tarjeta-premium",
                name: { es: "Tarjeta romántica premium", en: "Premium romantic card" },
                desc: { es: "Tus palabras, en una tarjeta especial.", en: "Your words, on a special card." },
                price: 6,
                image: "/extras/tarjeta.jpg",
            },
            {
                id: "rosa-roja",
                name: { es: "Una rosa roja", en: "A single red rose" },
                desc: { es: "A veces, una sola rosa lo dice todo.", en: "Sometimes a single rose says it all." },
                price: 10,
                image: "/extras/rosa.jpg",
            },
        ],
    },
    {
        id: "romantic-pack-supreme",
        handle: "pack-romantico",
        name: { es: "Pack Romántico", en: "Romantic Pack" },
        badge: { es: "Más popular", en: "Most popular" },
        desc: {
            es: "La experiencia completa: ramo de rosas frescas, osito personalizado y caja sorpresa con globos corazón. Todo llega junto, en el mismo instante.",
            en: "The complete experience: fresh roses bouquet, personalized teddy bear and a surprise box with heart balloons. All arrives together, in the same instant.",
        },
        images: [
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/7a381b4820a1c12a_14D068CD-C7C4-4AD5-B321-5A277BDF4349.png",
        ],
        options: {
            roseCounts: [
                { count: 25, price: 189 },
                { count: 50, price: 249 },
                { count: 100, price: 329 },
            ],
            shirt: false,
            message: true,
        },
        packExtras: {
            personalize: { price: 15, maxLength: 20 },
            shirtNameMaxLength: 15,
            cutoffHour: 18,
        },
        extras: [
            {
                id: "bruma-vs",
                name: { es: "Bruma Victoria’s Secret", en: "Victoria’s Secret body mist" },
                desc: { es: "Un toque especial para ella.", en: "A special touch for her." },
                price: 25,
                image: "/extras/bruma.jpg",
            },
            {
                id: "ferrero",
                name: { es: "Bombones Ferrero Rocher", en: "Ferrero Rocher chocolates" },
                desc: { es: "Un dulce detalle para sorprender.", en: "A sweet detail to surprise." },
                price: 12,
                image: "/extras/ferrero.jpg",
            },
            {
                id: "tarjeta-premium",
                name: { es: "Tarjeta romántica premium", en: "Premium romantic card" },
                desc: { es: "La tarjeta especial, aún más bonita.", en: "The special card, even prettier." },
                price: 6,
                image: "/extras/tarjeta.jpg",
            },
        ],
        includes: [
            { es: "Ramo de 25, 50 o 100 rosas frescas", en: "Bouquet of 25, 50 or 100 fresh roses" },
            { es: "Osito de peluche con T-shirt personalizado", en: "Teddy bear with personalized t-shirt" },
            { es: "Caja sorpresa con globos corazón de helio", en: "Surprise box with helium heart balloons" },
            { es: "Tarjeta con tu mensaje personalizado", en: "Card with your personalized message" },
        ],
    },
];

/* Fenêtre de livraison partagée par TOUS les produits (menu déroulant des créneaux).
   disabledSlots: heures "HH:MM" à désactiver (ex. ["12:00", "12:30"]). */
export const DELIVERY_WINDOW = {
    startHour: 8,
    endHour: 21,
    stepMinutes: 30,
    disabledSlots: [],
};

export const DEMO_IMAGES = {
    hero: "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/fdaae26099e3f180_CCC90629-CCF3-4D70-90BF-F96FDA1C81F7.png",
    placesBg:
        "https://images.unsplash.com/photo-1779917748329-5f17e8942599?q=85&w=1600&auto=format&fit=crop",
};

/* Avis clients (démo) — basés sur les photos réelles des livraisons.
   ⚠️ Textes de démonstration : à remplacer par les vrais avis clients. */
export const REVIEWS = [
    {
        name: "Carlos M.",
        image:
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/4ea507d0e8019a6e_IMG_7236.jpeg",
        es: "La esperé en el hotel y se quedó sin palabras al ver el ramo. Precioso.",
        en: "I waited for her at the hotel and she was speechless when she saw the bouquet. Beautiful.",
    },
    {
        name: "Andrea R.",
        image:
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/978c1f7539a4ca9d_IMG_7237.jpeg",
        es: "El osito gigante con el ramo y el globo quedó espectacular. Lloró de alegría.",
        en: "The giant teddy with the bouquet and balloon looked spectacular. She cried tears of joy.",
    },
    {
        name: "Javier P.",
        image:
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/b80cdde5e2fbd122_IMG_7238.jpeg",
        es: "Sorpresa para sus 30: fue directo a las fotos. Calidad de lujo.",
        en: "A surprise for her 30th: it went straight to the photos. Luxury quality.",
    },
    {
        name: "Marta G.",
        image:
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/d35babb78cf4e176_IMG_7239.jpeg",
        es: "La decoración de la habitación con los globos fue un detalle increíble. Repetiremos seguro.",
        en: "The bedroom decoration with the balloons was an incredible touch. We will definitely repeat.",
    },
    {
        name: "Sergio B.",
        image:
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/787b7a7412c933a0_IMG_7244.jpeg",
        es: "La esperé en el coche con los globos y el ramo. Se emocionó nada más subir.",
        en: "I waited in the car with the balloons and the bouquet. She was moved the moment she got in.",
    },
    {
        name: "Laura T.",
        image:
            "https://customer-assets-7cd3h4nn.emergentagent.net/job_cadeaux-marbella/artifacts/80c484306f686743_IMG_7243.jpeg",
        es: "La sorpresa la esperaba durmiendo: osito gigante y globos en la habitación. Increíble.",
        en: "The surprise was waiting while she slept: giant teddy and balloons in the room. Incredible.",
    },
];

/* Correspondance variantes Shopify (boutique yz20d1-hb.myshopify.com) */
export const SHOPIFY_VARIANTS = {
    "fresh-roses": {
        "25": "63903036080458",
        "50": "63903036113226",
        "75": "63903036145994",
        "100": "63903036178762",
    },
    "romantic-pack-supreme": {
        "25": "63903038013770",
        "50": "63903038046538",
        "100": "63903038079306",
    },
    "surprise-box-balloons": { default: "63903037423946" },
    "custom-teddy": {
        "beige|none": "63903036768586",
        "beige|negro": "63903036801354",
        "beige|blanco": "63903036834122",
        "marron|none": "63903036866890",
        "marron|negro": "63903036899658",
        "marron|blanco": "63903036932426",
    },
};

export const SHOPIFY_ADDONS = {
    bruma: "63903040667978",
    ferrero: "63903040733514",
    tarjeta: "63903040799050",
    rosa: "63903040864586",
    globo: "63903040897354",
    escritura: "63903040962890",
    textoTshirt: "63903041028426",
    persoPack: "63903041093962",
};
